import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Home from "@/pages/Home";
import MentionsLegales from "@/pages/MentionsLegales";
import ConditionsGenerales from "@/pages/ConditionsGenerales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import Diagnostic from "@/pages/Diagnostic";
import Ressources from "@/pages/Ressources";
import Ressource from "@/pages/Ressource";
import Methode from "@/pages/Methode";
import CadreJuridique from "@/pages/CadreJuridique";
import OutilInterne from "@/pages/OutilInterne";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Dereferencement from "@/pages/Dereferencement";
import SimonMarie from "@/pages/SimonMarie";
import HomeVeille from "@/pages/HomeVeille";
import NotFound from "@/pages/NotFound";
import { VEILLE_COMMERCIALE } from "@/config/siteFlags";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageProvider";
import BackToTop from "@/components/BackToTop";
import SEOHead from "@/components/SEOHead";
import SocialSchema from "@/components/SocialSchema";
import ScrollToTop from "@/components/ScrollToTop";

const ALL_PAGES = [
  ["/", Home],
  ["/audit-initial", Diagnostic],
  ["/contact", Contact],
  ["/desindexation", Dereferencement],
  ["/simon-marie", SimonMarie],
  ["/mentions-legales", MentionsLegales],
  ["/conditions-generales", ConditionsGenerales],
  ["/politique-confidentialite", PolitiqueConfidentialite],
  ["/methode", Methode],
  ["/cadre-juridique", CadreJuridique],
  ["/services", Services],
  ["/outil-interne", OutilInterne],
  ["/comprendre", Ressources],
  ["/comprendre/:slug", Ressource],
];

// Pages commerciales masquées pendant la veille (302 côté Netlify, Navigate côté SPA)
const VEILLE_HIDDEN = ["/methode", "/cadre-juridique", "/services", "/audit-initial", "/desindexation", "/conditions-generales"];

const PAGES = ALL_PAGES
  .filter(([path]) => !(VEILLE_COMMERCIALE && VEILLE_HIDDEN.includes(path)))
  .map(([path, Page]) => [path, VEILLE_COMMERCIALE && path === "/" ? HomeVeille : Page]);

// Legacy / defensive redirects for SEO continuity
const REDIRECTS = [
  ...(VEILLE_COMMERCIALE ? VEILLE_HIDDEN.map((p) => [p, "/"]) : []),
  ["/premiere-lecture", "/audit-initial"],
  ["/diagnostic", "/audit-initial"],
  ["/droits-rgpd", "/cadre-juridique"],
  ["/droits-rgpd/*", "/cadre-juridique"],
  ["/structure", "/methode"],
  ["/ressources", "/comprendre"],
  ["/resources", "/comprendre"],
  ["/services-accompagnement", "/services"],
  ["/en", "/"],
  ["/en/review", "/audit-initial"],
];

// Preserve slug when redirecting legacy /ressources/:slug (and /resources/:slug)
function RedirectSlug({ base }) {
  const { slug } = useParams();
  return <Navigate to={`${base}/${slug}`} replace />;
}

const TOAST_STYLE = {
  background: "#0A1128",
  color: "#F8F9FA",
  border: "none",
  borderRadius: "2px",
  fontFamily: "Manrope, sans-serif",
  fontSize: "13px",
  letterSpacing: "0.02em",
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SEOHead />
          <SocialSchema />
          <Routes>
            {PAGES.map(([path, Page]) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            {REDIRECTS.map(([from, to]) => (
              <Route key={from} path={from} element={<Navigate to={to} replace />} />
            ))}
            <Route path="/ressources/:slug" element={<RedirectSlug base="/comprendre" />} />
            <Route path="/resources/:slug" element={<RedirectSlug base="/comprendre" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <BackToTop />
        </BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{ style: TOAST_STYLE }} />
      </LanguageProvider>
    </div>
  );
}

export default App;
